import auth from './auth'
import user from './user'
import dom from './dom'
import toast from './toast'
import endpoint from './endpoint/index'
import common from './common'
import role from './role'
import merchant from './merchant'
import staff from './staff'
import callio from './callio'
import leads from './leads'
import search from './search'

export default {
  auth,
  user,
  dom,
  toast,
  endpoint,
  common,
  role,
  merchant,
  staff,
  callio,
  leads,
  search,
}
